{
  "metadata": {
    "id": "vesper-dark",
    "name": "Vesper",
    "description": "Портировано из темы «Vesper» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "vesper.json",
      "project": "raunofreiberg",
      "url": "https://github.com/raunofreiberg/vesper",
      "upstreamFile": "packages/ui/src/theme/themes/vesper.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 21.4,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.467,
      "paletteMaxS": 0.51,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.2,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.7,
      "syntaxVsTextMinDeltaE": 0,
      "chartsMinDeltaE": 22.2,
      "textSeparationDeltaE": 30.0,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "keyword",
          "deltaE": 8.0
        },
        {
          "a": "number",
          "b": "type",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#FFC799",
      "hover": "#ffcea5",
      "active": "#ffd2ad",
      "foreground": "#000000",
      "muted": "#ffc79980",
      "emphasis": "#FFC799"
    },
    "surface": {
      "background": "#101010",
      "foreground": "#FFF",
      "muted": "#262626",
      "mutedForeground": "#ababab",
      "elevated": "#2f2f2f",
      "elevatedForeground": "#FFF",
      "raised": "#494949",
      "raisedForeground": "#FFF",
      "overlay": "#101010cc",
      "subtle": "#1d1d1d"
    },
    "interactive": {
      "border": "#4c4c4c",
      "borderHover": "#535353",
      "borderFocus": "#FFC799",
      "selection": "#ffffff29",
      "selectionForeground": "#FFF",
      "focus": "#ffc79959",
      "focusRing": "#ffc79961",
      "cursor": "#ffffff",
      "hover": "#ffffff1c",
      "active": "#ffffff29"
    },
    "status": {
      "error": "#FF8080",
      "errorForeground": "#000000",
      "errorBackground": "#ff808024",
      "errorBorder": "#ff808073",
      "warning": "#FFC799",
      "warningForeground": "#000000",
      "warningBackground": "#ffc79924",
      "warningBorder": "#ffc79973",
      "success": "#99FFE4",
      "successForeground": "#000000",
      "successBackground": "#99ffe424",
      "successBorder": "#99ffe473",
      "info": "#FFC799",
      "infoForeground": "#000000",
      "infoBackground": "#ffc79924",
      "infoBorder": "#ffc79973"
    },
    "pr": {
      "open": "#99FFE4",
      "draft": "#ababab",
      "blocked": "#FFC799",
      "merged": "#FF8080",
      "closed": "#FF8080"
    },
    "syntax": {
      "base": {
        "background": "#323232",
        "foreground": "#FFF",
        "comment": "#9a9a9a",
        "keyword": "#a0a0a0",
        "string": "#99ffe4",
        "number": "#ffc799",
        "function": "#ffffff",
        "variable": "#FFF",
        "type": "#ffc799",
        "operator": "#afcfcf"
      },
      "tokens": {
        "commentDoc": "#9a9a9a",
        "stringEscape": "#afcfcf",
        "keywordImport": "#a0a0a0",
        "storageModifier": "#a0a0a0",
        "functionCall": "#ffffff",
        "method": "#ffffff",
        "variableProperty": "#ffffff",
        "variableOther": "#FFF",
        "variableGlobal": "#ffc799",
        "variableLocal": "#afcfcf",
        "parameter": "#FFF",
        "constant": "#ffc799",
        "class": "#ffc799",
        "className": "#ffc799",
        "interface": "#ffc799",
        "struct": "#ffc799",
        "enum": "#ffc799",
        "typeParameter": "#ffc799",
        "namespace": "#ffc799",
        "module": "#a0a0a0",
        "tag": "#a0a0a0",
        "jsxTag": "#a0a0a0",
        "tagAttribute": "#ffffff",
        "tagAttributeValue": "#99ffe4",
        "boolean": "#ffc799",
        "decorator": "#a0a0a0",
        "label": "#ffffff",
        "regexp": "#99ffe4"
      }
    },
    "charts": {
      "series": [
        "#FFC799",
        "#ffe999",
        "#99FFE4",
        "#f6edcb",
        "#FF8080"
      ]
    },
    "chat": {
      "background": "#101010",
      "userMessage": "#FFF",
      "userMessageBackground": "#2f2f2f",
      "assistantMessage": "#FFF",
      "assistantMessageBackground": "#262626",
      "timestamp": "#ababab",
      "divider": "#4c4c4c",
      "typing": "#ababab"
    },
    "loading": {
      "spinner": "#FFC799",
      "spinnerTrack": "#262626",
      "skeleton": "#262626",
      "shimmer": "#3e3e3e"
    },
    "tools": {
      "background": "#262626",
      "border": "#4c4c4c",
      "headerHover": "#3c3c3c",
      "icon": "#FFC799",
      "title": "#FFF",
      "description": "#ababab",
      "edit": {
        "added": "#99FFE4",
        "addedBackground": "#99ffe424",
        "removed": "#FF8080",
        "removedBackground": "#ff808024",
        "modified": "#FFC799",
        "modifiedBackground": "#ffc79924",
        "lineNumber": "#ababab"
      }
    },
    "markdown": {
      "heading1": "#FFF",
      "heading2": "#FFF",
      "heading3": "#FFF",
      "heading4": "#FFF",
      "link": "#FFC799",
      "linkHover": "#ffcea5",
      "inlineCode": "#99ffe4",
      "inlineCodeBackground": "#262626",
      "blockquote": "#ababab",
      "blockquoteBorder": "#4c4c4c",
      "listMarker": "#ffc799bf",
      "bold": "#FFF",
      "italic": "#ffffffe6",
      "strikethrough": "#ababab",
      "hr": "#4c4c4c"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#ca6c62",
        "foreground": "#000000",
        "contrast": 5.83
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#e0b2a3",
        "foreground": "#000000",
        "contrast": 11.07
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cfb66b",
        "foreground": "#000000",
        "contrast": 10.56
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d3dfac",
        "foreground": "#000000",
        "contrast": 14.92
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#a3c873",
        "foreground": "#000000",
        "contrast": 11.07
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#6dcf6b",
        "foreground": "#000000",
        "contrast": 10.79
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#73c794",
        "foreground": "#000000",
        "contrast": 10.33
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#acded4",
        "foreground": "#000000",
        "contrast": 14.15
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#6bbacd",
        "foreground": "#000000",
        "contrast": 9.53
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#6b94c2",
        "foreground": "#000000",
        "contrast": 6.64
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5c63c5",
        "foreground": "#ffffff",
        "contrast": 5.19
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#9289d4",
        "foreground": "#000000",
        "contrast": 6.75
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a663c8",
        "foreground": "#000000",
        "contrast": 5.24
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d2a7da",
        "foreground": "#000000",
        "contrast": 10.28
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#ca64a9",
        "foreground": "#000000",
        "contrast": 5.91
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d78ba0",
        "foreground": "#000000",
        "contrast": 8.09
      }
    ]
  }
}
